import { getLogger } from '../utils/SearchLogger';

export default class LocalStorageImpl implements IStorageImplementation {
	clear(): void {
		window.localStorage.clear();
	}
	setItem(key: string, value: Record<string, any>): void {
		try {
			window.localStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			getLogger().error('Local Storage Utils', 'Error writing to Local Storage', e.toString());
		}
	}

	// Executes the getItem
	getItem(key: string): Record<string, any> | null {
		let item: Record<string, any> | null = null;

		try {
			const localStorageItem = window.localStorage.getItem(key);

			if (localStorageItem) {
				// We JSON.parse it for you so that you don't have to
				item = JSON.parse(localStorageItem);
			}
		} catch (e) {
			getLogger().error('Local Storage Utils', 'Error reading from Local Storage', e.toString());
		}

		return item;
	}

	// Executes the removeItem
	removeItem(key: string): void {
		window.localStorage.removeItem(key);
	}
}
